<template>
  <app-card title="優惠代碼">
    <v-card-text>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              label="優惠代碼"
              prepend-icon="local_offer"
              placeholder="輸入優惠代碼"
              color="black"/>
          </v-flex>

          <v-flex xs12>
            <v-alert
              v-show="errMsg"
              transition="slide-y-transition"
              :value="true"
              type="error">
              {{errMsg}}
            </v-alert>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        :loading="loading"
        @click="submit"
        flat>
        送出
      </v-btn>
    </v-card-actions>
  </app-card>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      errMsg: null
    };
  },

  methods: {
    submit() {}
  }
};
</script>

<style lang="stylus" scoped>
</style>
